shadow$provide[254] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, HTML:{enumerable:true, get:function() {
  return HTML;
}}});
var require$_DOT__DOT__SLASH_data_SLASH_voxel_DOT_js = require("../data/voxel.js");
class HTML extends require$_DOT__DOT__SLASH_data_SLASH_voxel_DOT_js.Voxel {
  static initClass() {
    this.traits = ["node", "buffer", "active", "data", "voxel", "html"];
    this.finals = {channels:1};
  }
  init() {
    super.init();
    this.storage = "pushBuffer";
  }
  make() {
    super.make();
    const {items, width, height, depth} = this.getDimensions();
    this.dom = this._overlays.make("dom");
    return this.dom.hint(items * width * height * depth);
  }
  unmake() {
    super.unmake();
    if (this.dom != null) {
      this.dom.dispose();
      return this.dom = null;
    }
  }
  update() {
    return super.update();
  }
  change(changed, touched, init) {
    if (touched["html"]) {
      return this.rebuild();
    }
    return super.change(changed, touched, init);
  }
  nodes() {
    return this.buffer.read();
  }
  callback(callback) {
    const {el} = this.dom;
    if (callback.length <= 6) {
      return (emit, i, j, k, l) => callback(emit, el, i, j, k, l);
    } else {
      return (emit, i, j, k, l) => {
        return callback(emit, el, i, j, k, l, this.bufferClock, this.bufferStep);
      };
    }
  }
}
HTML.initClass();

};